module.exports = __webpack_public_path__ + "39e79310d82cbbca70e2aedb75dd431b.pdf";